import * as React from 'react';
import { PageProps } from "src/models/common/ComponentProps";
import bindAllOfThis from "src/utils/BindThisHelper";
import PhaserGamePadDemo from 'src/games/demos/phaserGamePadDemo/Main';

interface GamePadDemoProps extends PageProps<{}> {
}

class GamePadDemo extends React.Component<GamePadDemoProps> {
    private game: Phaser.Game;
    constructor(props: GamePadDemoProps) {
        super(props);
        bindAllOfThis(this, GamePadDemo.prototype);
    }

    render() {
        return (<div>
            <PhaserGamePadDemo />
        </div>);
    }
}

export default GamePadDemo;



// WEBPACK FOOTER //
// ./src/pages/game/demos/GamePadDemo.tsx